import React, { useState, useRef, useEffect } from 'react'
import { HiMenu, HiX } from 'react-icons/hi'
import { canDeleteHrRequest } from '../../utils/hrRequestApproval';

// Utility function to check if user has admin privileges (admin or super role)
const hasAdminPrivileges = (role) => {
  return role === 'admin' || role === 'super';
};

const App_Navbar = ({ currentView, setCurrentView, getNavLabel, userProfile }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuTop, setMenuTop] = useState(0);
  const mobileBarRef = useRef(null);

  const updateMenuTop = () => {
    if (mobileBarRef.current) {
      setMenuTop(mobileBarRef.current.getBoundingClientRect().bottom);
    }
  };

  useEffect(() => {
    if (!menuOpen) return;

    updateMenuTop();
    window.addEventListener('resize', updateMenuTop);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('resize', updateMenuTop);
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const handleNavClick = (view) => {
    setCurrentView(view);
    setMenuOpen(false);
  };

  return (
    <div className={`min-w-0 w-full app-nav-wrapper${menuOpen ? ' app-nav-wrapper--open' : ''}`}>
      <div className="w-full min-w-0">
        <div className="app-nav-mobile-bar" ref={mobileBarRef}>
          <button
            type="button"
            className="app-nav-toggle"
            onClick={() => setMenuOpen((open) => !open)}
            aria-expanded={menuOpen}
            aria-controls="main-navigation"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            {menuOpen ? <HiX /> : <HiMenu />}
          </button>
          <span className="app-nav-mobile-label">Menu</span>
        </div>
        <nav
          id="main-navigation"
          className={`app-nav touch-manipulation${menuOpen ? ' app-nav--open' : ''}`}
          aria-label="Main navigation"
          style={menuOpen ? { top: `${menuTop}px` } : undefined}
        >
          <button
            className={currentView === 'dashboard' ? 'active' : ''}
            onClick={() => handleNavClick('dashboard')}
          >
            Dashboard
          </button>
          {(userProfile?.role === 'manager' || hasAdminPrivileges(userProfile?.role)) && (
            <button
              className={`text-nowrap ${currentView === 'profile' ? 'active' : ''}`}
              onClick={() => handleNavClick('profile')}
            >
              {getNavLabel('profile')}
            </button>
          )}
          <button
            className={`text-nowrap ${currentView === 'employees' ? 'active' : ''}`}
            onClick={() => handleNavClick('employees')}
          >
            {getNavLabel('employees')}
          </button>
          {(hasAdminPrivileges(userProfile?.role) || userProfile?.role === 'manager') && (
            <button
              className={`text-nowrap ${currentView === 'organization' ? 'active' : ''}`}
              onClick={() => handleNavClick('organization')}
            >
              Organization Chart
            </button>
          )}
          {hasAdminPrivileges(userProfile?.role) && (
            <button
              className={`text-nowrap ${currentView === 'positions' ? 'active' : ''}`}
              onClick={() => handleNavClick('positions')}
            >
              Positions Management
            </button>
          )}
          {userProfile?.role === 'manager' && (
            <button
              className={`text-nowrap ${currentView === 'my_team_requests' ? 'active' : ''}`}
              onClick={() => handleNavClick('my_team_requests')}
            >
              My Team Requests
            </button>
          )}
          <button
            className={`text-nowrap ${currentView === 'requests' ? 'active' : ''}`}
            onClick={() => handleNavClick('requests')}
          >
            {getNavLabel('requests')}
          </button>
          {hasAdminPrivileges(userProfile?.role) && (
            <button
              className={`text-nowrap ${currentView === 'my_leave_requests' ? 'active' : ''}`}
              onClick={() => handleNavClick('my_leave_requests')}
            >
              {getNavLabel('my_leave_requests')}
            </button>
          )}
          <button
            className={`text-nowrap ${currentView === 'admin_requests' ? 'active' : ''}`}
            onClick={() => handleNavClick('admin_requests')}
          >
            Admin Requests
          </button>
          {canDeleteHrRequest(userProfile) && (
            <button
              className={`text-nowrap ${currentView === 'deleted_requests' ? 'active' : ''}`}
              onClick={() => handleNavClick('deleted_requests')}
            >
              Deleted Requests
            </button>
          )}
          {hasAdminPrivileges(userProfile?.role) && (
            <button
              className={`text-nowrap ${currentView === 'my_admin_requests' ? 'active' : ''}`}
              onClick={() => handleNavClick('my_admin_requests')}
            >
              {getNavLabel('my_admin_requests')}
            </button>
          )}
          <button
            className={`text-nowrap ${currentView === 'checkInOut' ? 'active' : ''}`}
            onClick={() => handleNavClick('checkInOut')}
          >
            Check In/Out
          </button>
          {(hasAdminPrivileges(userProfile?.role) || userProfile?.role === 'manager') && (
            <button
              className={`text-nowrap ${currentView === 'allCheckInOut' ? 'active' : ''}`}
              onClick={() => handleNavClick('allCheckInOut')}
            >
              {userProfile?.role === 'manager' ? 'Team Check In/Out' : 'All Check In/Out'}
            </button>
          )}
          {userProfile?.role === 'super' && (
            <button
              className={`text-nowrap ${currentView === 'shifts' ? 'active' : ''}`}
              onClick={() => handleNavClick('shifts')}
            >
              Shift Management
            </button>
          )}
          {hasAdminPrivileges(userProfile?.role) && (
            <button
              className={`text-nowrap ${currentView === 'grades' ? 'active' : ''}`}
              onClick={() => handleNavClick('grades')}
            >
              Grade Management
            </button>
          )}
          <button
            className={`text-nowrap ${currentView === 'announcements' ? 'active' : ''}`}
            onClick={() => handleNavClick('announcements')}
          >
            Announcements
          </button>
          <button
            className={`text-nowrap ${currentView === 'policies_trainings' ? 'active' : ''}`}
            onClick={() => handleNavClick('policies_trainings')}
          >
            Seazen Policies and Trainings
          </button>
          {hasAdminPrivileges(userProfile?.role) && (
            <button
              className={`text-nowrap ${currentView === 'locations' ? 'active' : ''}`}
              onClick={() => handleNavClick('locations')}
            >
              Location Management
            </button>
          )}
          <button
            className={`text-nowrap opacity-30 pointer-events-none`}
          >
            {getNavLabel('payslips')} {'(Coming Soon)'}
          </button>
        </nav>
      </div></div>
  )
}

export default App_Navbar
